import View from './sub-navigation-view';
import ResponsiveSubNavigation from './responsive-sub-navigation';

export default View;
export { ResponsiveSubNavigation };
